//文字コードはutf-8

// GSAP は lib/gsap.min.js ほか（グローバル）を使用
const { gsap, ScrollTrigger, SplitText, CustomEase } = window;
const GSAP_READY = !!(gsap && ScrollTrigger && SplitText && CustomEase);

if (GSAP_READY) {
    gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase);
}

/* .jsTitleReveal を付けた要素の「1文字ずつせり上がる」出現アニメーション
 * - 要素内テキストを GSAP SplitText で分割し、進入時にマスクの下からせり上げる
 * - 発火は ScrollTrigger（画面外での誤発火を防ぐ）
 * - data-reveal-trigger : ScrollTrigger の基準にする祖先セレクタ（省略時は要素自身）
 * - data-reveal-stagger : 文字ごとのディレイ秒（省略時 0.04）
========================================================*/

const REVEAL_SELECTOR = '.jsTitleReveal';

// なめらかな出現イージング（急激なスナップを避けてガタつきを軽減）
const APPEAR_EASE = GSAP_READY ? CustomEase.create('appear', 'M0,0 C0.16,1 0.3,1 1,1') : null;

export function initTitleReveal() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // ライブラリ未読込 / モーション低減時はアニメーションしない。
    // CSS で opacity:0 にした .jsTitleReveal を即表示へ戻す（非表示のままにしない）。
    if (!GSAP_READY || reduce) {
        revealTargets(document.querySelectorAll(REVEAL_SELECTOR));
        return;
    }

    // フォント読み込み後にセットアップ（分割の計測を安定させる）
    const ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    ready.then(setupReveals);
}

function setupReveals() {
    document.querySelectorAll(REVEAL_SELECTOR).forEach(revealChars);
    // レイアウト確定後にトリガー位置を再計算
    ScrollTrigger.refresh();
}

// 要素内テキストを SplitText で1文字に分割し、進入時にせり上げる
function revealChars(el) {
    // 非表示の要素は分割せず、表示だけ戻す
    if (getComputedStyle(el).display === 'none') {
        revealTargets([el]);
        return;
    }

    const triggerSel = el.dataset.revealTrigger;
    const trigger = (triggerSel && el.closest(triggerSel)) || el;
    const stagger = parseFloat(el.dataset.revealStagger) || 0.04;

    // data-reveal-targets があれば個々の子要素を分割する。
    // （絶対配置や <br> を含む要素はコンテナごと分割すると崩れるため）
    const targetSel = el.dataset.revealTargets;
    const targets = targetSel ? el.querySelectorAll(targetSel) : [el];
    const chars = [];
    targets.forEach((t) => {
        if (getComputedStyle(t).display === 'none') return;
        chars.push(...SplitText.create(t, { type: 'chars', mask: 'chars', charsClass: 'char++' }).chars);
    });
    if (!chars.length) {
        revealTargets([el]);
        return;
    }

    gsap.set(chars, { willChange: 'transform', force3D: true });

    gsap.from(chars, {
        yPercent: 100,
        duration: 1.1,
        ease: APPEAR_EASE,
        stagger,
        force3D: true,
        scrollTrigger: {
            trigger,
            start: 'top 85%',
            once: true,
        },
        // アニメーション後もwillChangeが残ると文字数分のレイヤーが常駐し続け、
        // PCの大きい見出し（フォントサイズ・同時表示数とも多い）ほどスクロールが
        // カクつく原因になる。完了後はレイヤー昇格を解除する。
        onComplete: () => gsap.set(chars, { clearProps: 'willChange' }),
    });
    revealTargets([el]);
}

function revealTargets(elements) {
    elements.forEach((el) => {
        el.style.opacity = '1';
    });
}
